import {
  Component,
  Input,
  forwardRef,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
  AfterContentInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-search-dropdown',
    templateUrl: './search-dropdown.component.html',
    styleUrls: ['./search-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchDropdownComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SearchDropdownComponent
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  @Output() afterChange = new EventEmitter();
  @ViewChild('input', { static: false }) input: ElementRef | undefined;
  @Input('size') size: any;
  @Input('items') set items(value: any) {
    this.list = value;
    this.temp_list = value;
  }
  @Input('componentName') componentName: string | undefined;
  @Input('label') label: string | undefined;
  @Input('uid') uid: string | undefined;
  @Input('placeholder') placeholder: any;
  @Input() isDisabled: boolean = false;
  // Default functions for Angular form control bridging
  onChange: any = () => {}; // Handles value changes
  onTouch: any = () => {}; // Handle Touch changes (i.e, touch)
  shown = false;
  list = [];
  temp_list: any = [];
  keyword = '';
  _componentName: any;
  _label: any;
  _uid: any;
  _placeholder: any;

  constructor(private ele: ElementRef) {}
  ngOnInit(): void {}

  ngAfterContentInit(): void {
    this._placeholder = this.placeholder;
  }

  ngOnChanges() {
    this._label = //to show on dropdown
      typeof this.label !== 'undefined' && this.label !== ''
        ? this.label
        : 'name';
    this._componentName = // to uniquely identify components types
      typeof this.componentName !== 'undefined' && this.componentName !== ''
        ? this.componentName
        : '';
    this._uid = // to uiquely identify options among themselves
      typeof this.uid !== 'undefined' && this.uid !== '' ? this.uid : 'id';
    this._placeholder =
      typeof this.placeholder !== 'undefined' &&
      this.placeholder !== null &&
      this.placeholder
        ? this.placeholder
        : '';
  }

  writeValue(value: any) {
    /**calls when getting default value from parent component to child component
     * Basically whenever formContol value will be changed outside this component i.e, from parent,  we will get that value and use that to show on component ui
     */
    if (value) {
      this.temp_list.map((x: any) => {
        if (x[this._label] == value) {
          this._placeholder = x[this._label]; // for changed value
        }
      });
    } else {
      this._placeholder = this.placeholder; // for default placeholder
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  search(e: string) {
    // used when type in dropdown
    const val = e.toLowerCase();
    if (!val) {
      // If search string is empty, reset the list to its original state
      this.list = this.temp_list;
    } else {
      this.list = this.temp_list.filter((x: any) => {
        // Filter based on whether the label contains the search string
        return x[this._label].toLowerCase().includes(val);
      });
    }
  }

  select(item: { [x: string]: any }) {
    this._placeholder = item[this._label];
    this.onChange(item[this._label]);
    this.fnReset();
    this.afterChange.emit(item);
  }

  show() {
    this.shown = true;
    setTimeout(() => {
      this.input?.nativeElement.focus();
    }, 200);
    if (this.list.length === 0) {
      this.list = this.temp_list;
    }
  }

  // for mouse click
  @HostListener('document:click', ['$event']) onClick(e: { target: any }) {
    if (!this.ele.nativeElement.contains(e.target)) {
      this.fnReset();
    }
  }

  // for keyboard keys
  @HostListener('document:keydown.enter', ['$event'])
  onEnterKey(e: Event) {
    const keyboardEvent = e as KeyboardEvent; // type assertion
    keyboardEvent.preventDefault();
  }

  fnReset() {
    this.shown = false;
    this.keyword = '';
    this.list = this.temp_list;
  }

  fnGetName(placeholderValue: any) {
    this._placeholder = placeholderValue;
  }
}
